import fmt from 'date-fns/format'
import ru from 'date-fns/locale/ru'

const formatSeconds = (seconds: number) => {
  return seconds.toString().padStart(2, '0')
}

const formatDate = (date: Date | number, str: string) => {
  if (!date) return null

  try {
    return fmt(date, str, { locale: ru })
  } catch {
    return null
  }
}

const stringDateToObject = (date: string) => {
  if (!date) return null

  try {
    return new Date(date)
  } catch {
    return null
  }
}

export const PREVIEW_DATE_TIME_FORMAT = 'dd MMM yyyy, HH:mm'

const formatDateTimeStringToPreview = (date: string) => {
  return formatDate(stringDateToObject(date), PREVIEW_DATE_TIME_FORMAT)
}

const daysToMs = (days: number) => days * 86400000

const sToDays = (s: number) => s / 86400

const timeUtils = { formatSeconds, formatDate, formatDateTimeStringToPreview, sToDays, daysToMs }

export default timeUtils
